import {constants, mediaQueryStyles as mq} from '@newsela/angelou';
import {css} from 'emotion';

import {breakpointSwitch} from '../style';

// Subtract 1 pixel so the upTo function does not include mq.Breakpoint.xs
export const smallestScreenBreakpoint = mq.mediaQuery.upTo(
  constants.legacy_breakpoints.Breakpoints.xs - 1
);

export const smallBreakpoint = mq.mediaQuery.upTo(
  constants.breakpoints.BreakpointNames.sm
);

const {
  colors: {ui},
} = constants;

export const buttonStyles = {
  '&&': {
    width: '100%',
    height: '100%',
    [breakpointSwitch]: {
      ':hover *, :focus *': {
        color: ui.greyDark['700'],
        stroke: ui.greyDark['700'],
      },
    },
  },
};

export const buttonWithPopOutStyle = {
  drawerButtonContents: {
    span: {color: ui.grey['700']},
  },
  root: {
    [smallBreakpoint]: {
      height: '100%',
      width: '100%',
    },
  },
  Button: {
    root: {
      ...buttonStyles,
      fontSize: '1rem',
      [smallBreakpoint]: {
        padding: 0,
        justifyContent: 'center',
        svg: {
          height: '24px',
        },
      },
    },
  },
  PopOut: {
    popOutContents: {
      textAlign: 'left',
      overflowY: 'auto',
      maxHeight: 'min(500px, calc(100vh - var(--content_offset_top)))',
      [smallBreakpoint]: {
        bottom: '25px',
      },
      li: {
        listStyle: 'none',
        width: '235px',
        textAlign: 'left',
        [smallBreakpoint]: {
          width: '100%',
        },
      },
    },
  }
};

const commonIconStyles = {
  width: '24px',
  height: '24px',
  gridArea: 'icon',
  marginBottom: '8px',
  [smallestScreenBreakpoint]: {
    alignSelf: 'center',
    marginBottom: 0,
  },
};

export const globalNavStyle = (hideGlobalNav) =>
  css({
    // 72 -1 for the border
    height: '71px',
    borderTop: `1px solid ${ui.greyLight['100']}`,
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: '100%',
    backgroundColor: ui.white['500'],
    display: hideGlobalNav ? 'none' : null,
    [breakpointSwitch]: {
      borderTop: 0,
      height: '64px',
      padding: 0,
      position: 'relative',
      overflow: 'visible',
    },
  });

export const ulStyle = {
  listStyle: 'none',
  padding: 0,
  height: '100%',
  margin: 0,
  display: 'grid',
  gridAutoColumns: '20%',
  gridAutoFlow: 'column',
  [breakpointSwitch]: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: '32px',
    alignItems: 'center',
  },
};

export const liStyle = {
  position: 'relative',
  [breakpointSwitch]: {
    padding: '0 8px',
    marginRight: '16px',
  },
};

export const searchFormStyle = {
  marginBottom: '5px',
};

export const inactiveButtonStyle = {
  visibility: 'hidden',
};

export const topLevelLinkStyle = {
  width: '100%',
  height: '100%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [breakpointSwitch]: {
    display: 'flex',
    ':hover *, :focus *': {
      color: ui.greyDark['700'],
      stroke: ui.greyDark['700'],
    },
  },
};

export const listItemLinkStyle = {
  display: 'block',
  width: '100%',
  ':hover, :focus': {
    color: ui.greyDark[700],
  },
};

export const iconStyle = (isActive) => ({
  ...commonIconStyles,
  stroke: isActive ? ui.coreBlue['500'] : ui.grey['700'],
});

export const assignmentIconStyle = {
  ...commonIconStyles,
  stroke: ui.grey['700'],
};
